import {
  CreateCustomerRequest,
  Customer,
  UpdateCustomerRequestDto,
} from '@interfaces/customer.interface';

import api from './';

export const {
  useCreateCustomerMutation,
  useFindCustomerQuery,
  useUpdateCustomerMutation,
} = api.injectEndpoints({
  endpoints: (build) => ({
    createCustomer: build.mutation<Customer, CreateCustomerRequest>({
      query: ({ body, recaptchaToken }) => ({
        url: 'customers',
        method: 'POST',
        body,
        headers: {
          'x-grecaptcha': recaptchaToken,
        },
      }),
    }),
    findCustomer: build.query<Customer, void>({
      query: () => ({
        url: 'customers/current',
        method: 'GET',
      }),
      providesTags: ['customers'],
    }),
    updateCustomer: build.mutation<Customer, UpdateCustomerRequestDto>({
      query: (body) => ({
        url: 'customers/current',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['customers'],
    }),
  }),
});
